import { Route, Routes } from "react-router";
import CountryPage from "../../components/country-page/country-page.component";
const Countries = () => {
  return (
    <Routes>
      <Route path=":name" element={<CountryPage />} />
    </Routes>
  );
};

export default Countries;
